// extracted by mini-css-extract-plugin
export default {"outerCon":"RoundelPicture_outerCon__zXi4Y","introPictureRoundel":"RoundelPicture_introPictureRoundel__Eob60","circle":"RoundelPicture_circle__MEA-X"};